import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app'
import session from './modules/session'
import files from './modules/files'
import breadcrumbRoutes from './modules/breadcrumbRoutes'

const store = new Vuex.Store({
    state: {
        //
    },
    mutations: {
        //
    },
    actions: {

    },
    modules: {
        app,
        session,
        files,
        breadcrumbRoutes
    }
});

export default store;